export default {
  init() {
    // JavaScript to be fired on the home page
    jQuery(function ($) {
      $('.carousel-indicators > li:nth-of-type(1)').click(function () {
        $("#myCarousel").carousel(0);
      });
      $('.carousel-indicators > li:nth-of-type(2)').click(function () {
        $("#myCarousel").carousel(1);
      });
      $('.carousel-indicators > li:nth-of-type(3)').click(function () {
        $("#myCarousel").carousel(2);
      });
      $('#free-white-paper-learn-more').click(function(e) {
        ga('send', 'event', 'Internal Clicks', 'Clicked Get Your FREE White Paper', 'On-Demand Processing 101 White Paper link in Home page');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js